/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.thinkprocess.TodoStatus
*/
export var TodoStatus;
(function (TodoStatus) {
    TodoStatus["PENDING"] = "PENDING";
    TodoStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TodoStatus["COMPLETED"] = "COMPLETED";
})(TodoStatus || (TodoStatus = {}));
//# sourceMappingURL=TodoStatus.js.map